import { Image, Users, Gift, Handshake, Ticket, Vote } from "lucide-react";
import { useLang } from "@/i18n";
import { SectionHead, Reveal } from "@/components/common";

const ICONS = [Image, Users, Gift, Handshake, Ticket, Vote];

export function Benefits() {
  const { t } = useLang();
  return (
    <section className="section-pad py-24" data-testid="benefits-section">
      <SectionHead eyebrow={t("benefits.eyebrow")} title={t("benefits.title")} sub={t("benefits.sub")} />
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {ICONS.map((Icon, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <div className="card-surface flex items-center gap-4 p-6" data-testid={`benefit-${i + 1}`}>
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-neon/25 bg-neon/[0.07]">
                <Icon size={20} className="text-neon" />
              </div>
              <div>
                <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-paper">{t(`benefits.b${i + 1}`)}</h3>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-gold/80">{t("common.planned")}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
